import React from "react";
import { useNavigate } from "react-router-dom";
import { MdLocalHospital } from "react-icons/md";
import { FaBuilding, FaArrowRight } from "react-icons/fa";

const WardCard = ({ ward }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/new/setup/ward-management/${ward.id}`);
  };

  return (
    <div className="rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition duration-300">
      <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-4 flex items-center justify-between">
        <h4 className="text-lg font-bold text-white">{ward.wardName}</h4>
        <MdLocalHospital className="text-white text-xl" />
      </div>
      <div className="p-4 bg-white">
        <div className="flex items-center space-x-2">
          <FaBuilding className="text-blue-500" />
          <p className="text-gray-600 text-sm">Department: {ward.department}</p>
        </div>
        <button
          onClick={handleViewDetails}
          className="mt-4 w-full bg-indigo-500 text-white py-2 rounded hover:bg-indigo-600 transition duration-300 flex items-center justify-center"
        >
          View Details <FaArrowRight className="ml-2" />
        </button>
      </div>
    </div>
  );
};

export default WardCard;
